import {
  CgCustomDomainRoutingRecord,
  CgCustomDomainStatus,
} from '@provision/landing-page-utils';
import { type CgCustomDomain } from 'src/graphql/entities/cg-custom-domain/cg-custom-domain.types';

export const FALLBACK_EXAMPLE_APEX = 'yourcompany.com';

export enum CgCustomDomainDisplayState {
  Waiting = 'waiting',
  Finishing = 'finishing',
  Live = 'live',
  Stopped = 'stopped',
}

type DomainState = Pick<CgCustomDomain, 'status' | 'routingRecord'>;

export function getCgCustomDomainDisplayState(
  domain: DomainState,
): CgCustomDomainDisplayState {
  switch (domain.status) {
    case CgCustomDomainStatus.Active:
      return CgCustomDomainDisplayState.Live;
    case CgCustomDomainStatus.Failed:
      return CgCustomDomainDisplayState.Stopped;
    case CgCustomDomainStatus.Validated:
      return CgCustomDomainDisplayState.Finishing;
    default:
      return domain.routingRecord === CgCustomDomainRoutingRecord.Found
        ? CgCustomDomainDisplayState.Finishing
        : CgCustomDomainDisplayState.Waiting;
  }
}

export function isRoutingRecordFound(domain: DomainState): boolean {
  return getCgCustomDomainDisplayState(domain) !== CgCustomDomainDisplayState.Waiting;
}

/** Splits `membership.partner.com` into the record name most DNS providers want and the zone. */
export function splitHostname(hostname: string): { label: string; apex: string } {
  const labels = hostname.split('.');

  return { label: labels.slice(0, -2).join('.'), apex: labels.slice(-2).join('.') };
}
